import React from 'react'
import { useTranslation } from 'react-i18next'
import ResponsiveBreakpointsRolloutBoundary from 'components/ResponsiveBreakpointsRolloutBoundary'
import { RESPONSIVE_BREAKPOINT_PAGES } from 'constants/responsiveBreakpoints'
import { FlaggedContent } from './FlaggedContent'

export const FlaggedWithRollout = () => {
  const { t } = useTranslation()

  return (
    <ResponsiveBreakpointsRolloutBoundary
      fallback={
        <div className="p-8 text-white" aria-live="polite" role="status">
          {t('general.loading')}
        </div>
      }
      page={RESPONSIVE_BREAKPOINT_PAGES.FLAGGED}
    >
      <FlaggedContent />
    </ResponsiveBreakpointsRolloutBoundary>
  )
}

export default FlaggedWithRollout
